import {MouseEvent} from 'react';

import {isHtmlElement} from '../../../../../libs/shared/helpers/src/browser/domHelpers';
import {ChartEventHandlers} from '../commons/types';

interface GenerateEventHandlers<T> extends ChartEventHandlers<T> {
  isLoading?: boolean;
}

export function generateEventHandlers<T>({onHover, onUnhover, onClick, isLoading}: GenerateEventHandlers<T>) {
  return (d: T) => ({
    onFocus: () => !isLoading && onHover && onHover(d),
    onMouseOver: (event: MouseEvent) =>
      !isLoading &&
      isHtmlElement(event.target) &&
      onHover &&
      onHover(d, event.target.getBoundingClientRect()),
    onMouseLeave: () => !isLoading && onUnhover && onUnhover(),
    onClick: () => !isLoading && onClick && onClick(d),
  });
}
